const anyQbEntered = (ids, objects) => {
  return ids.map(id => objects.find(el => el.id == id).status).some(status => status == 'Pending')
}

export default anyQbEntered
